module.exports = __webpack_public_path__ + "img/popup_warning.ca029809.png";